import httpDriver from 'app/utils/httpDriver';
import { TMutation, TQuery } from 'app/Requests/types';
import { checkTranslated } from 'app/utils/helpers';
import { apiRoutes } from 'posts/utils/apiRoutes';
import { apiRoutes as reportsApiRoutes } from 'reports/utils/apiRoutes';

export const queryName = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.get('');
  return data;
};

export const requestName = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post('');
  return data;
};

export const getPostsMediaTypes = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.instagramPostsMediaType);
  return data?.payload?.records;
};
export const loadInstagramDetails = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes.instagramDetails, body);
  return data?.payload?.records;
};
export const getUsersRowsData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1].slug, queryKey[1].body);
  return data?.payload?.records;
};

export const addInstagramPost = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.storeInstagramPost, body);
  return data;
};
export const getRegrabPosts = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.instagramRegrabPosts, {
    ids: [+id],
  });
  return { ...data, successMessage };
};
export const getRegrabPostComments = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.instagramRegrabPostComments,
    {
      id: id,
    },
  );
  return { ...data, successMessage };
};
export const getRegrabReplies = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabRepliesConversation, {
    id: id,
  });
  return { ...data, successMessage };
};

export const deleteIncompletePosts = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteIncompletePosts, {
    data: { ids: [+id] },
  });
  return { ...data, successMessage };
};

export const changeInstagramPostsCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.changeCommentsCategories,
    body,
  );
  return data;
};

export const instagramSentimentAnalysisAdd = async ({
  post_id,
  words,
  hashtags,
  category,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.instagramSentimentAnalysisAdd,
    {
      post_id,
      words,
      hashtags,
      category,
    },
  );
  return data;
};

export const tiktokSentimentAnalysisAdd = async ({
  post_id,
  words,
  hashtags,
  category,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tiktokSentimentAnalysisAdd, {
    post_id,
    words,
    hashtags,
    category,
  });
  return data;
};
export const getSorting = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.commentsSorting, {});
  return data?.payload?.records;
};

export const updateSentimentAnalysis = async ({
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(
    apiRoutes.instagramUpdateSentimentAnalysis,
    {
      post_id: Number(id),
      sets,
      words,
      hashtags,
    },
  );
  return data;
};

export const getColumnsSentimentData = async ({
  id,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.instagramShowSentiment, {
    category: type,
    post_id: Number(id),
  });
  return data?.payload?.records;
};

export const getMostFreqWords = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.mostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getMostFreqHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.mostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getCommentsDataList = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.commentsList,
    queryKey[1].body,
  );
  return data;
};

export const deleteIncompleteTiktokPosts = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(
    apiRoutes.tiktokDeleteIncompletePosts,
    {
      data: { ids: [+id] },
    },
  );
  return { ...data, successMessage };
};
export const addTiktokPost = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tiktokAddPost, body);
  return data;
};
export const loadTiktokDetails = async ({ queryKey }: TQuery): Promise<any> => {
  const { body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes.tiktokDetails, body);
  return data?.payload?.records;
};

export const resyncTrendingTiktok = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokTrendingRegrabPosts,
    body,
  );
  return data;
};

export const resyncTrendingYoutube = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.trendingYoutubeRegrabPosts,
    body,
  );
  return data;
};
export const loadYoutubeDetails = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes.youtubeDetails, body);
  return data?.payload;
};
export const getRegrabTiktokPosts = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tiktokRegrabPosts, {
    ids: [+id],
  });
  return { ...data, successMessage };
};
export const getRegrabPostTiktokComments = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tiktokRegrabPostComments, {
    id: id,
  });
  return { ...data, successMessage };
};
export const getRegrabTiktokReplies = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokRegrabRepliesConversation,
    {
      id: id,
    },
  );
  return { ...data, successMessage };
};
export const changeTiktokPostsCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokChangeCommentsCategories,
    body,
  );
  return data;
};
export const getTiktokPostSorting = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tiktokCommentsSorting, {});
  return data?.payload?.records;
};

export const updateTiktokSentimentAnalysis = async ({
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(
    apiRoutes.tiktokUpdateSentimentAnalysis,
    {
      post_id: Number(id),
      sets,
      words,
      hashtags,
    },
  );
  return data;
};

export const getTiktokColumnsSentimentData = async ({
  id,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tiktokShowSentiment, {
    category: type,
    post_id: Number(id),
  });
  return data?.payload?.records;
};

export const getTiktokMostFreqWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokMostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getTiktokMostFreqHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokMostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getTiktokCommentsDataList = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokCommentsList,
    queryKey[1].body,
  );
  return data;
};
export const getTiktokRegrabReplies = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.tiktokRegrabRepliesConversation,
    {
      id: id,
    },
  );
  return { ...data, successMessage };
};

export const getRegrabLinkedinPosts = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.linkedinRegrabPosts, {
    ids: [+id],
  });
  return { ...data, successMessage };
};
export const getRegrabPostLinkedinComments = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.linkedinRegrabPostComments, {
    post_id: id,
  });
  return { ...data, successMessage };
};
export const deleteIncompleteLinkedinPosts = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deletePost, {
    data: { ids: [+id] },
  });
  return { ...data, successMessage };
};
export const loadLinkedinDetails = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes.linkedinDetails, body);
  return data?.payload?.records;
};
export const addLinkedinPost = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.storeLinkedinPost, body);
  return data;
};
export const getLinkedinPostSorting = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.linkedinCommentsSorting, {});
  return data?.payload?.records;
};
export const getLinkedinPostsMediaTypes = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.linkedinPostsMediaType);
  return data?.payload?.records;
};

export const updateLinkedinSentimentAnalysis = async ({
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(
    apiRoutes.linkedinUpdateSentimentAnalysis,
    {
      post_id: Number(id),
      sets,
      words,
      hashtags,
    },
  );
  return data;
};
export const getLinkedinMostFreqHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.linkedinMostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getLinkedinMostFreqWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.linkedinMostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getLinkedinColumnsSentimentData = async ({
  id,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.linkedinShowSentiment, {
    category: type,
    post_id: Number(id),
  });
  return data?.payload?.records;
};
export const changeLinkedinPostsCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.linkedinChangeCommentsCategories,
    body,
  );
  return data;
};
export const linkedinSentimentAnalysisAdd = async ({
  post_id,
  words,
  hashtags,
  category,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.linkedinSentimentAnalysisAdd,
    {
      post_id,
      words,
      hashtags,
      category,
    },
  );
  return data;
};
export const deleteIncompleteTweets = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteTweet, {
    data: { ids: [+id] },
  });
  return { ...data, successMessage };
};

export const getRegrabTweet = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabTweet, {
    ids: [+id],
  });
  return { ...data, successMessage };
};

export const getRegrabTweetReplies = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabTweetReplies, {
    tweet_id: id,
  });
  return { ...data, successMessage };
};
export const getTweetTypes = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tweetTypes, {});
  return (
    data?.payload?.records.map((opt: any) => {
      return { value: opt.id, label: checkTranslated(opt?.name, opt?.name_ar) };
    }) || []
  );
};
export const loadTwitterDetails = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes.tweetDetails, body);
  return data?.payload?.records;
};

export const getRegrabTweetRepliesConversations = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.regrabTweetRepliesConversations,
    {
      tweet_id: id,
    },
  );
  return { ...data, successMessage };
};
export const changeTweetQuoteCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.changeTweetQuotes, body);
  return data;
};

export const changeTweetReplyCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.changeTweetReplies, body);
  return data;
};
export const postTwitterSentimentAnalysisAdd = async ({
  tweet_id,
  words,
  hashtags,
  category,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tweetSentimentAnalysisAdd, {
    tweet_id,
    words,
    hashtags,
    category,
  });
  return data;
};
export const getYoutubeSentimentAnalysisAdd = async ({
  post_id,
  words,
  hashtags,
  category,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.youtubeSentimentAnalysisAdd,
    {
      post_id,
      words,
      hashtags,
      category,
    },
  );
  return data;
};
export const getTwitterMostFreqWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.twitterMostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getTwitterMostFreqHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.twitterMostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getTwitterColumnsSentimentData = async ({
  id,
  isInfluencerModule,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.showTweetSentiment, {
    category: type,
    tweet_id: Number(id),
  });
  return data?.payload?.records;
};
export const updateTwitterSentimentAnalysis = async ({
  isInfluencerModule,
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateTweetSentiment, {
    tweet_id: Number(id),
    sets,
    words,
    hashtags,
  });
  return data;
};
export const addTwitterPost = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addTwitterPost, body);
  return data;
};
export const fastReportBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(reportsApiRoutes.fastReport, {
    item_ids: body.item_ids || [],
    template_id: body.template_id,
    report_name: body.report_name,
    ...body?.bulkFilter,
    ...body,
  });
  return data;
};
export const addClientVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addClientVideos, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const unnecessaryVideos = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.unnecessaryVideo, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteVideo, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

export const restoreVideo = async ({
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreVideo, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const trashVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashVideo, { ids: [id] });
  return { ...data, successMessage };
};
export const addVideo = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addVideo, body);
  return data;
};

export const hideVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.hideVideo, { ids: [id] });
  return { ...data, successMessage };
};
export const regrabYoutubeVideos = async ({
  id,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabVideo, {
    video_ids: [id],
  });
  return data;
};

export const getRegrabYoutubePosts = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabVideo, {
    video_ids: [+id],
  });
  return { ...data, successMessage };
};
export const getRegrabPostYoutubeComments = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.youtubeRegrabPostComments, {
    id: id,
  });
  return { ...data, successMessage };
};
export const getRegrabYoutubeReplies = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.youtubeRegrabRepliesConversation,
    {
      id: id,
    },
  );
  return { ...data, successMessage };
};
export const changeYoutubePostsCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.youtubeChangeCommentsCategories,
    body,
  );
  return data;
};
export const getYoutubePostSorting = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.youtubeCommentsSorting, {});
  return data?.payload?.records;
};

export const getRelatedTags = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.youtubeRelatedTags, {
    video_id: queryKey[1],
    is_sample: queryKey[2],
  });
  return data?.payload?.records;
};

export const getTrendingListVideo = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.youtubeTrendingList, {
    video_id: queryKey[1],
    is_sample: queryKey[2],
  });
  return data?.payload?.records;
};
export const getLastGrabbedOn = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.youtubeLastGrabbedOn);
  return data?.payload;
};

export const updateYoutubeSentimentAnalysis = async ({
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(
    apiRoutes.youtubeUpdateSentimentAnalysis,
    {
      post_id: Number(id),
      sets,
      words,
      hashtags,
    },
  );
  return data;
};

export const getYoutubeColumnsSentimentData = async ({
  id,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.youtubeShowSentiment, {
    category: type,
    post_id: Number(id),
  });
  return data?.payload?.records;
};

export const getYoutubeMostFreqWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.youtubeMostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getYoutubeMostFreqHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.youtubeMostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
